module.exports = __webpack_public_path__ + "static/img/image4.b068f583.png";